// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"629":"28a4c878","687":"7e58cd8a","768":"cc064b28","969":"7e58cd8a"}[chunkId] + ".css";
};